import { Controller } from "@hotwired/stimulus"

/*
This lets a checkbox (the 'trigger' target) control the visibility of other elements (any element
that is a 'subject' target).
You can optionally have multiple checkboxes controlling different subsets of elements within the
same reveal-controller by adding matching 'data-reveal-group' attributes to both the trigger and 
the subject(s).
Should probably enhance this in the future to support enable/disable instead of just visibility,
and possibly other trigger types.
*/
export default class extends Controller {
  static targets = ["trigger", "subject"]

  connect() {
    requestAnimationFrame(() => {
      // Only trigger reveal for radios if they are checked on load
      this.triggerTargets.forEach(trigger => {
        if (trigger.type !== "radio" || trigger.checked) {
          this.handleReveal(trigger);
        }
  
        // Always attach listeners for future interaction
        trigger.addEventListener("input", () => {
          this.handleReveal(trigger);
        });
      });
    });
  }

  handleReveal(trigger) {
    let enabled;

    if (trigger.type === "radio" && trigger.checked) {
      enabled = trigger.value === "true"
    } else if (trigger.type === "select-one") { // for single select dropdowns
      // Use case is when other is selected, an input text will appear.
      enabled = trigger.value === "other";
    } else if (trigger.type !== "radio" ) { // avoid updating for radio buttons in nil state
      enabled = trigger.checked;
    }

    // Check if this trigger should use inverted logic
    const isInverted = trigger.dataset.revealInverted === "true";
    if (isInverted) {
      enabled = !enabled;
    }

    const revealGroup = trigger.dataset.revealGroup;


    this.subjectTargets.filter(subject => subject.dataset.revealGroup == revealGroup).forEach(subject => {
      if (enabled) {
        subject.classList.remove("hidden");
      } else if (enabled === false) { // nothing happens for nil
        subject.classList.add("hidden");
      }
    });
  }
}
